import * as React from "react";
import {UIState} from "data/UIState";
import DashboardData from "data/DashboardData";
import {observer} from "mobx-react";
import {DashboardTopBar} from "components/dashboard/DashboardTopBar";
import {SolutionCard} from "components/dashboard/SolutionCard";
import {AllYearCard} from "./AllYearCard";
import {DashboardSolution} from "data/entities/DashboardSolution";

import './Dashboard.pcss';
import {DashboardBadgeBlock} from "components/badges/DashboardBadgeBlock";
import {PlatformAdminNotification} from "components/dashboard/PlatformAdminNotification";
import {NotOpenYet} from "components/dashboard/NotOpenYet";
import {NotificationsContainer} from "components/widgets/Notification/NotificationsContainer";
import {CollapsedNotification, NotificationTypeHelper} from "data/entities/INotification";
import {action} from "mobx";



@observer
export class Dashboard extends React.Component {

  handleDashboardSolutionClick = (dashboardSolution:DashboardSolution) => {
    UIState.selectDashboardSolution(dashboardSolution);
  }

  handleNotificationNav = action((collapsedNotification:CollapsedNotification) => {
    DashboardData.dismissNotification(collapsedNotification);
    if(NotificationTypeHelper.containsMentionsOrReplies(collapsedNotification)) {
      UIState.collapsedNotificationTarget = collapsedNotification; //commentMentionTarget;
      const dashboardSolution = DashboardData.allDashboardSolutions.find((dashboardSolution) => dashboardSolution._id === collapsedNotification.solutionId);
      if (dashboardSolution) {
        this.handleDashboardSolutionClick(dashboardSolution);
      }
    }
  })

  render() {
    if (!DashboardData.loaded) {
      return <span>loading dashboard...</span>
    } else {

      return (
        <div>

          <div className={"dashboard"}>

            <DashboardTopBar customerName={UIState.settings.COMPANY_NAME} />

            <div className={"cont"}>

              <PlatformAdminNotification />

              <NotOpenYet />

              {DashboardData.active.length > 0 &&
                <>
                  <h2 aria-label={"Active and upcoming programs"}>Active & Upcoming</h2>
                  <ul className={"reset"} role="group" aria-label={"Active & Upcoming"}>
                    {DashboardData.active.map(solution => {
                      return (
                        <li key={solution._id}>
                          <SolutionCard solution={solution} onClick={this.handleDashboardSolutionClick}  />
                        </li>
                      );
                    })
                    }
                  </ul>
                </>
              }

              {DashboardData.annual.length > 0 && <>
                <h2>{DashboardData.active.length==0 ? "" : "Ongoing"}</h2>
                <ul className={"reset available-all-year"} >
                  {DashboardData.annual.map((dashboardSolution, idx) => {
                    const liClassName = idx>0 && (idx+1)%3==0 ? 'end' : '';
                    return (
                      <li key={dashboardSolution._id} className={liClassName}>
                        <AllYearCard
                          title={dashboardSolution.name}
                          subTitle={dashboardSolution.cardSubTitle}
                          photo={dashboardSolution.photoObject}
                          buttonAction={()=>{ this.handleDashboardSolutionClick(dashboardSolution);}}
                          openInNewTab={dashboardSolution.isDashboardLink}
                        />
                      </li>
                    );
                  })}
                </ul>
              </>}

              <DashboardBadgeBlock badgedDashboardSolutions={DashboardData.badgedDashboardSolutions} />

            </div>

            {UIState.showNotifications &&
              <NotificationsContainer
                collapsedNotifications={DashboardData.collapsedNotifications}
                onDismissCollapsedNotification={DashboardData.dismissNotification}
                onCollapsedNotificationNav={this.handleNotificationNav}
                delay={1}
              />
            }

          </div>

        </div>
      );
    }


  }
}
